import { useCallback, useEffect, useState } from 'react';
import {
  orcamentosApi,
  type OrcamentoResumo,
  type StatusOrcamento,
} from '@/features/orcamentos/api/orcamentosApi';
import { useSyncReload } from '@/shared/hooks/useSyncReload';

type Estado = {
  orcamentos: OrcamentoResumo[];
  carregando: boolean;
  erro: string | null;
};

export function useOrcamentos() {
  const [estado, setEstado] = useState<Estado>({
    orcamentos: [],
    carregando: false,
    erro: null,
  });

  const recarregar = useCallback(() => {
    setEstado((s) => ({ ...s, carregando: true, erro: null }));
    return orcamentosApi.listar().then(
      (orcamentos) => setEstado({ orcamentos, carregando: false, erro: null }),
      (e: unknown) => {
        const mensagem = e instanceof Error ? e.message : 'Erro desconhecido';
        setEstado({ orcamentos: [], carregando: false, erro: mensagem });
      },
    );
  }, []);

  const alterarStatus = useCallback(
    async (id: string, status: StatusOrcamento) => {
      await orcamentosApi.alterarStatus(id, status);
      await recarregar();
    },
    [recarregar],
  );

  const excluir = useCallback(
    async (id: string) => {
      await orcamentosApi.excluir(id);
      await recarregar();
    },
    [recarregar],
  );

  useEffect(() => {
    void recarregar();
  }, [recarregar]);

  useSyncReload(recarregar);

  return { ...estado, recarregar, alterarStatus, excluir };
}
